export const EURO_CURRENCY_CODE = 'EUR'; //in the future this can be calcualated based on ip location
